var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMailIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 102,
    viewBox: "0 0 128 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M109.046 12.7599V11.4319H112.054V22.9999H110.582V12.7599H109.046Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.5 0.711182C105.254 0.711182 99.8444 4.28636 97.209 9.49996H12.975C5.83418 9.49996 0 15.3341 0 22.475V88.325C0 95.4658 5.83418 101.3 12.975 101.3H100.775C107.916 101.3 113.75 95.4658 113.75 88.325V32.5232C121.521 31.4305 127.5 24.7606 127.5 16.6956C127.5 7.86764 120.337 0.711182 111.5 0.711182ZM12.975 13.5H95.8198C95.6101 14.5325 95.5 15.6012 95.5 16.6956C95.5 21.7311 97.8307 26.2228 101.473 29.1527L58.8752 58.9713L5.1471 21.3617C4.83319 21.1419 4.4781 21.0249 4.12175 21.0035C4.83022 16.7639 8.54405 13.5 12.975 13.5ZM4 25.4413V88.325C4 93.2566 8.04332 97.3 12.975 97.3H100.775C105.707 97.3 109.75 93.2566 109.75 88.325V32.5854C108.162 32.4129 106.643 32.0081 105.23 31.4058L60.0221 63.0511C59.3335 63.5331 58.4169 63.5331 57.7282 63.0511L4 25.4413ZM99.5 16.6956C99.5 10.0746 104.873 4.70728 111.5 4.70728C118.127 4.70728 123.5 10.0746 123.5 16.6956C123.5 23.3165 118.127 28.6839 111.5 28.6839C104.873 28.6839 99.5 23.3165 99.5 16.6956Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIcon);
export default __webpack_public_path__ + "static/media/mailIcon.09dae5680f69a5a75e20bbd3949c4b05.svg";
export { ForwardRef as ReactComponent };